import { EVENT_TYPE_PAYMENT_FAILED, EVENT_TYPE_PAYMENT_SUCCEED } from "./constants/index.js";

export default (eventType) => {
  return [EVENT_TYPE_PAYMENT_FAILED, EVENT_TYPE_PAYMENT_SUCCEED].indexOf(eventType) >= 0;
};
